import styles from './styles.module.scss';

import { useContext, useEffect, useState } from 'react';
import TrilogicIconLogin from '../../../../assets/images/icons/trilogic-icon-login.png';
import { useNavigate } from 'react-router-dom';
import { LoginBox } from '../../../../components/LoginBox';
import { MessageContext } from '../../../../providers/MessageProvider';
import { updateUser } from './requestHandlers';
import { Error, User } from '../../../../types';
import {
    sysCanSaveImages,
    logout,
    prepareUserObject,
    saveSessionCredentials,
    verifyRoutePermissions
} from '../../../../globalFunctions';
import { LoadingContext } from '../../../../providers/LoadingProvider';
import { UpdateUserCredentials } from './types';
import TrilogicPolicies from '../../../../assets/files/trilogic_termo_de_uso_e_politica_de_privacidade_v2.pdf';
import { MediaContentDAO } from '../../../../classes/MediaContentDAO';

export const UpdateUserRoute = () => {
    const [userAuth, setUserAuth] = useState<User>({} as User);
    const { setOpenMessage, setMessage } = useContext(MessageContext);
    const { setIsLoadingContent } = useContext(LoadingContext);
    const navigate = useNavigate();

    const [openLoginBox, setOpenLoginBox] = useState<boolean>(true);
    const [image, setImage] = useState<File>();
    const [previewImageURL, setPreviewImageURL] = useState<string>('');
    const [gender, setGender] = useState<string>();
    const [agreedLgpd, setAgreedLgpd] = useState<'0' | '1'>('0');

    const handleBackPress = async () => {
        const result = await logout(userAuth.token, navigate);

        if (result && typeof result === 'object' && Object.keys(result).includes('error')) {
            const error = result as Error;

            setMessage({
                type: 'error',
                content: error.message
            });
            setOpenMessage(true);
        }
    };

    const afterUpdate = (user: User) => {
        user = prepareUserObject(user);
        setUserAuth(user);

        console.log(user)

        // Save session and navigate to main page
        saveSessionCredentials(user);
        navigate('/');
    };

    const validateInputCredentials = () => {
        let message = '';

        if (userAuth.gender === null && gender === undefined) {
            message = 'Preencha o campo de gênero';
        } else if (userAuth.image === null && image === undefined && sysCanSaveImages()) {
            message = 'Selecione uma imagem de perfil';
        } else if (!userAuth.lgpd_agreed && agreedLgpd === '0') {
            message = 'Você deve aceitar os termos de uso e privacidade para prosseguir';
        }

        if (message === '') {
            return true;
        } else {
            setMessage({
                type: 'warning',
                content: message
            });
            setOpenMessage(true);

            return false;
        }
    };

    const handleUserUpdate = async (event: React.ChangeEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (validateInputCredentials()) {
            try {
                setIsLoadingContent(true);

                const updatedUser = {} as UpdateUserCredentials;

                if (userAuth.gender === null || userAuth.gender === undefined) {
                    updatedUser.gender = gender;
                }

                if (userAuth.image === null || userAuth.image === undefined) {
                    updatedUser.image = {
                        id: 0,
                        file: image,
                        url: ''
                    };
                }

                if (!userAuth.lgpd_agreed || userAuth.lgpd_agreed === undefined) {
                    updatedUser.lgpd_agreed = agreedLgpd;
                }

                updatedUser.id = userAuth.id;

                const result = await updateUser(userAuth.token, navigate, updatedUser);

                if (
                    result &&
                    typeof result === 'object' &&
                    !Object.keys(result).includes('error')
                ) {
                    if (updatedUser.image) {
                        const mediaContent = await MediaContentDAO.store(
                            userAuth.token,
                            navigate,
                            updatedUser.id,
                            updatedUser.image,
                            'user'
                        );

                        if (
                            mediaContent &&
                            typeof mediaContent === 'object' &&
                            !Object.keys(mediaContent).includes('error')
                        ) {
                            result.image = mediaContent.image;
                        } else {
                            throw mediaContent;
                        }
                    }

                    setMessage({
                        type: 'success',
                        content: 'Dados atualizados com sucesso'
                    });
                    setOpenMessage(true);
                    console.log(result)
                    setTimeout(() => {
                        setIsLoadingContent(false);
                        afterUpdate(result as User);
                    }, 1000);
                } else {
                    throw result;
                }
            } catch (error: any) {
                setMessage({
                    type: 'error',
                    content: error.message
                });
                setOpenMessage(true);
            } finally {
                setIsLoadingContent(false);
            }
        }
    };

    const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            setImage(event.target.files[0]);

            const selectedImage = event.target.files[0];
            setImage(selectedImage);

            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewImageURL(reader.result as string);
            };
            reader.readAsDataURL(selectedImage);
        }
    };

    const handleAgreedLgpd = () => {
        if (agreedLgpd === '0') {
            setAgreedLgpd('1');
        } else {
            setAgreedLgpd('0');
        }
    };

    const showPolicies = () => {
        window.open(TrilogicPolicies);
    };

    useEffect(() => {
        const user = verifyRoutePermissions(['auth'], navigate);

        if (typeof user === 'object') {
            setUserAuth(user);
        }
    }, []);

    return (
        <div className={styles.wrapper}>
            <div className={styles.mainLeft}></div>
            <div className={styles.mainRight}>
                <img src={TrilogicIconLogin} alt='Logo do Trilogic' />
            </div>

            <LoginBox open={openLoginBox}>
                <div className={`${styles.loginOption} ${styles.credentials}`}>
                    <div className={`${styles.optionHeader} ${styles.centralize}`}>
                        Atualização cadastral
                    </div>

                    <form onSubmit={handleUserUpdate} encType='multipart/form-data'>
                        {(userAuth.gender === null || userAuth.gender === undefined) && (
                            <div className={styles.groupField}>
                                <label className={styles.required}>Gênero</label>

                                <div className={`${styles.groupField} ${styles.option}`}>
                                    <input
                                        type='radio'
                                        key='genderMale'
                                        id='genderMale'
                                        name='gender'
                                        value='M'
                                        onChange={event => setGender(event.target.value)}
                                    />
                                    <label htmlFor='genderMale'>Masculino</label>
                                </div>
                                <div className={`${styles.groupField} ${styles.option}`}>
                                    <input
                                        type='radio'
                                        key='genderFemale'
                                        id='genderFemale'
                                        name='gender'
                                        value='F'
                                        onChange={event => setGender(event.target.value)}
                                    />
                                    <label htmlFor='genderFemale'>Feminino</label>
                                </div>
                                <div className={`${styles.groupField} ${styles.option}`}>
                                    <input
                                        type='radio'
                                        key='genderNonBinary'
                                        id='genderNonBinary'
                                        name='gender'
                                        value='N'
                                        onChange={event => setGender(event.target.value)}
                                    />
                                    <label htmlFor='genderNonBinary'>Não binário</label>
                                </div>
                                <div className={`${styles.groupField} ${styles.option}`}>
                                    <input
                                        type='radio'
                                        key='genderNotMention'
                                        id='genderNotMention'
                                        name='gender'
                                        value='NM'
                                        onChange={event => setGender(event.target.value)}
                                    />
                                    <label htmlFor='genderNotMention'>Prefiro não mencionar</label>
                                </div>
                            </div>
                        )}

                        {(userAuth.image === null || userAuth.image === undefined) &&
                            sysCanSaveImages() && (
                                <div className={`${styles.groupField} ${styles.imageUploadField}`}>
                                    <label className={styles.required}>Imagem de perfil</label>

                                    <div className={styles.imageButton}>
                                        <label htmlFor='image' aria-hidden='true'>
                                            Selecione uma imagem
                                        </label>
                                        <input
                                            type='file'
                                            accept='image/*'
                                            id='image'
                                            name='image'
                                            onChange={handleImageChange}
                                        />
                                    </div>

                                    {previewImageURL !== '' && (
                                        <figure>
                                            <img
                                                src={previewImageURL}
                                                alt='Imagem de perfil do usuário'
                                            />
                                            <figcaption>{image && image.name}</figcaption>
                                        </figure>
                                    )}
                                </div>
                            )}

                        {(!userAuth.lgpd_agreed || userAuth.lgpd_agreed === undefined) && (
                            <div className={`${styles.groupField} ${styles.lgpd} ${styles.option}`}>
                                <input
                                    type='checkbox'
                                    name='agreedLgpd'
                                    id='agreedLgpd'
                                    value={agreedLgpd}
                                    onChange={handleAgreedLgpd}
                                />
                                <label htmlFor='agreedLgpd'>
                                    Declaro que li e concordo com o{' '}
                                    <a href='#' target='_blank' onClick={showPolicies}>
                                        Termo de Uso e Política de Privacidade
                                    </a>{' '}
                                    da plataforma. Além disso, confirmo que as informações
                                    fornecidas neste formulário de cadastro são verdadeiras.
                                </label>
                            </div>
                        )}

                        <button
                            type='submit'
                            className={`${styles.loginOption} ${styles.submitButton}`}
                        >
                            Atualizar cadastro
                        </button>

                        <button
                            type='button'
                            className={`${styles.loginOption} ${styles.redButton}`}
                            onClick={handleBackPress}
                        >
                            Sair da conta
                        </button>
                    </form>
                </div>
            </LoginBox>
        </div>
    );
};
